import { render, staticRenderFns } from "./RegisterRiderSend.vue?vue&type=template&id=682023ff&scoped=true"
import script from "./RegisterRiderSend.vue?vue&type=script&lang=js"
export * from "./RegisterRiderSend.vue?vue&type=script&lang=js"
import style0 from "./RegisterRiderSend.vue?vue&type=style&index=0&id=682023ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682023ff",
  null
  
)

export default component.exports